import { Component, input, output, signal } from '@angular/core';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { BarcodeFormat } from '@zxing/library';
import { UiModule } from '@components/ui/ui-module';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'lgb-scan-binder',
  imports: [
    UiModule,
    CommonModule,
    ZXingScannerModule
  ],
  templateUrl: './scan-binder.html',
  styleUrl: './scan-binder.css',
})
export class ScanBinder{

  // Scanner
  readonly scannerEnabled=input.required({alias: 'enabled'});
  readonly allowedFormats=[BarcodeFormat.QR_CODE];

  // Devices
  readonly hasDevices=signal(false);
  readonly devices=signal<MediaDeviceInfo[]>([]);
  readonly selectedDevice=signal<MediaDeviceInfo | undefined>(undefined);

  // Résultat / erreurs
  readonly lastResult=signal<string | null>(null);
  readonly error=signal<string | null>(null);

  //evt
  readonly success=output<string>();
  readonly onError=output<string>({alias: 'error'});
  readonly close=output<boolean>();

  onCamerasFound(devices: MediaDeviceInfo[]){
    this.hasDevices.set(devices.length > 0);
    this.devices.set(devices);

    // Choix auto: tente caméra arrière (label souvent dispo après autorisation)
    const preferred=devices.find(d => /back|rear|environment/i.test(d.label)) ?? devices[0];

    this.selectedDevice.set(preferred);
  }

  onCamerasNotFound(){
    this.hasDevices.set(false);
    this.error.set("Aucune caméra détectée.");
    this.doError();
  }

  onScanSuccess(qrText: string){
    // Évite multi-trigger si la cam "relit" le QR
    if(this.lastResult()!==qrText){

      this.lastResult.set(qrText);

      // Exemple: tu peux parser ton QR ici (token, binderId, URL, etc.)
      // Puis activer via API et/ou naviguer.
      // ex: /binder/activate?token=...
      //this.router.navigate(['/binder/activate'], { queryParams: { qr: qrText } });
      this.success.emit(qrText);
      this.error.set(null);
    }
  }

  onScanError(err: any){
    console.error(err);
    this.error.set("Erreur de scan (permission refusée ? caméra occupée ?).");
    this.doError();
  }

  selectDevice(deviceId: string) {
    const device=this.devices().find(d => d.deviceId === deviceId);
    this.selectedDevice.set(device);
  }

  doError(){
    this.onError.emit(this.error());
  }

  back(){
    this.close.emit(true);
  }
}
